import { createRouter, createWebHistory } from "@ionic/vue-router";
import { RouteRecordRaw } from "vue-router";
import { storage } from "@/common/services/storage";
import { logout } from "@/common/services/auth.service";
import MainTabs from "@/home/views/MainTabs.vue";

const Admin = () => import("@/admin/views/AdminPage.vue");

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/login/views/LoginView.vue"),
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("@/login/views/SignupView.vue"),
  },
  {
    path: "/password-reset",
    name: "PasswordReset",
    component: () => import("@/login/views/PasswordRecoveryView.vue"),
  },
  {
    path: "/auth/callback",
    name: "OAuthCallback",
    component: () => import("@/login/views/OAuthCallbackView.vue"),
  },
  {
    path: "/",
    component: MainTabs,
    redirect: "/matches",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "groups",
        name: "Groups",
        component: () => import("@/home/views/GroupsPage.vue"),
      },
      {
        path: "competitions",
        name: "Competitions",
        component: () => import("@/home/views/CompetitionsPage.vue"),
      },
      {
        path: "matches",
        name: "Matches",
        component: () => import("@/home/views/MatchesPage.vue"),
      },
      {
        path: "groups/:id",
        name: "Group",
        component: () => import("@/groups/views/GroupTabs.vue"),
      },
      {
        path: "account",
        name: "Account",
        component: () => import("@/home/views/AccountPage.vue"),
      },
      {
        path: "competitions/:id",
        name: "Competition",
        component: () => import("@/competitions/views/CompetitionTabs.vue"),
      },
      {
        path: "admin",
        name: "Admin",
        component: Admin,
        children: [
          {
            path: "",
            name: "AdminDashboard",
            component: () => import("@/admin/views/DashboardPage.vue"),
          },
          {
            path: "competitions",
            name: "AdminCompetitions",
            component: () => import("@/admin/views/CompetitionsPage.vue"),
          },
          {
            path: "competitions/:id",
            name: "AdminCompetitionPage",
            component: () => import("@/admin/views/CompetitionPage.vue"),
          },
          {
            path: "notifications",
            name: "AdminNotifications",
            component: () => import("@/admin/views/NotificationsPage.vue"),
          },
          {
            path: "sync-configs",
            name: "AdminSyncConfigs",
            component: () => import("@/admin/views/SyncConfigsPage.vue"),
          },
          {
            path: "stats",
            name: "AdminStats",
            component: () => import("@/admin/views/StatsPage.vue"),
          },
          {
            path: "summary-videos",
            name: "AdminSummaryVideos",
            component: () => import("@/admin/views/SummaryVideosPage.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = await storage.get("token");

  if (!token) {
    if (to.meta.requiresAuth) {
      await logout();
      return next({ name: "Login" });
    }
  } else if (to.name === "Login") {
    return next({ name: "Matches" });
  }

  return next();
});

export default router;
